import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Feature {
  icon: string;
  title: string;
  description: string;
}

interface KeyFeaturesProps {
  features: Feature[];
}

const KeyFeatures = ({ features }: KeyFeaturesProps) => {
  return (
    <section className="py-20 bg-card">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Belangrijkste functies
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Ontdek de krachtige mogelijkheden die uw bedrijf transformeren
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="glassmorphic rounded-xl p-8 hover:shadow-premium transition-all duration-300 group hover:-translate-y-1"
            >
              <div className="relative mb-6">
                <div className="absolute inset-0 bg-primary/20 rounded-lg blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="relative w-14 h-14 bg-gradient-to-br from-primary to-secondary rounded-lg flex items-center justify-center">
                  <Icon name={feature.icon as any} size={28} className="text-background" />
                </div>
              </div>
              
              <h3 className="text-xl font-display font-bold text-foreground mb-3">
                {feature.title}
              </h3>
              
              <p className="text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;